module.exports = __webpack_public_path__ + "static/media/aramco.fe23af97.png";